import React from 'react'
import { styled } from 'styled-components'
import { mapEntries } from '../../utility/functions'
import {
	getConnectedStudents,
	getStudentsWithSurveys,
	useMissionStateSelector,
} from '../../context'
import { ConnectedVideo } from '../basics'

const POST_SURVEY_LOADING_VIDEO =
	'https://resources-cdn.mission.io/videos/PostMissionDiagnostics.mp4'

export default function SurveyResponses({
	generatingAnalytics,
}: {
	generatingAnalytics: boolean,
}): React$Node {
	const finishedStudents = useMissionStateSelector(getStudentsWithSurveys)
	const connectedStudents = useMissionStateSelector(getConnectedStudents)

	return (
		<Container>
			{generatingAnalytics ? (
				<ConnectedVideo url={POST_SURVEY_LOADING_VIDEO} />
			) : (
				<>
					<Phrase>Now Collecting Mission Results</Phrase>
					<ResponseModal>
						{mapEntries(connectedStudents, student => {
							return (
								<SurveyResponse
									hasSubmitted={finishedStudents.has(student.id)}
									key={student.id}>
									{student.lastName
										? student.firstName + ' ' + student.lastName
										: student.firstName}
								</SurveyResponse>
							)
						})}
					</ResponseModal>
				</>
			)}
		</Container>
	)
}

const Container = styled.div`
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	text-align: center;
	align-items: center;
	justify-content: center;
`

const Phrase = styled.h1`
	font-size: 10em !important;
	margin: 0 !important;
`

const ResponseModal = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
`

const SurveyResponse = styled.h6.attrs({ className: 'font-game-headline' })`
	background-color: ${({ hasSubmitted }) =>
		hasSubmitted ? '#00b5af' : '#151540'};
	color: white;
	padding: 2em;
	margin: 1em !important;
	border-radius: 1em;
`
